import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import { Article, getArticles } from '../../utils/contentful';

const Home: React.FC = () => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        setLoading(true);
        const fetchedArticles = await getArticles();
        
        // Sort articles by date in descending order (newest first)
        const sortedArticles = [...fetchedArticles].sort((a, b) => {
          return new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime();
        });
        
        setArticles(sortedArticles);
      } catch (err) {
        setError('Failed to load articles');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  if (loading) {
    return (
      <div className="home">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading articles...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="home">
        <div className="error-container">
          <h2>Error</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="home">
      <div className="hero-section">
        <h1 className="main-title">Engineering Musings & Beyond</h1>
        <p className="tagline">A personal blog covering whatever I feel like talking about, usually around engineering</p>
      </div>
      
      <div className="articles-grid">
        {articles.map((article) => (
          <Link to={`/article/${article.slug}`} key={article.slug} className="article-card">
            <h2>{article.title}</h2>
            <p className="article-date">
              {new Date(article.publishDate).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
          </Link>
        ))}
      </div>
      
      <footer className="home-footer">
        <p>© {new Date().getFullYear()} MvB Blog. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Home;